import FinishProposalLogin from './FinishProposalLogin';

export default FinishProposalLogin;
